import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash.substring(1);
      const params = new URLSearchParams(hash);
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error('Invalid authentication');
        navigate('/login');
        return;
      }

      try {
        const response = await fetch(`${API}/auth/google`, {
          method: 'POST',
          headers: { 
            'Accept': 'application/json',
            'Content-Type': 'application/json' 
          },
          body: JSON.stringify({ session_id: sessionId })
        });

        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.detail || 'Authentication failed');
        }

        // Store token in localStorage
        if (data.token) {
          localStorage.setItem('auth_token', data.token);
        }

        toast.success('Welcome!');
        navigate('/dashboard', { state: { user: data }, replace: true });
      } catch (error) {
        toast.error(error.message || 'Authentication failed');
        navigate('/login');
      }
    };

    processSession();
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAEDCD]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#3A5A40] mx-auto mb-4"></div>
        <p className="text-[#3A5A40] text-lg">Completing sign in...</p>
      </div>
    </div>
  );
}